import type { ReactNode } from 'react';

export const symbol_south_america: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M324-111.5Q251-143 197-197t-85.5-127Q80-397 80-480t31.5-156Q143-709 197-763t127-85.5Q397-880 480-880t156 31.5Q709-817 763-763t85.5 127Q880-563 880-480t-31.5 156Q817-251 763-197t-127 85.5Q563-80 480-80t-156-31.5ZM480-140l-30-30q-7-7-9.5-14.43-2.5-7.42-2.5-15.91V-438q-35.06 0-60.03-24.67Q353-487.35 353-522v-42.67L220-698q-38 45-59 100.15-21 55.15-21 117.73Q140-338 238.81-239q98.82 99 241.19 99Zm42-2q127-17 212.5-112T820-479.77q0-141.41-99.41-240.82T479.78-820q-46.78 0-89.28 12T310-774v82h150.88q19.12 0 36.62 8 17.5 8 29.5 24l59.38 74H650q17 0 29.5 12.5T692-544v45.13q0 9.68-2.5 18.27Q687-472 682-464L522-224.89V-142Z"
		/>
	</svg>
);
